var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6539 2.72088L5.91331 12.0637L0.574219 6.71736L1.39974 5.89296L5.83287 10.3321L12.7555 1.97656L13.6539 2.72088Z",
    fill: "#67B75A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSuccessIcon);
export default __webpack_public_path__ + "static/media/greenSuccessIcon.46cc2ba2fe745476e0305797d60c39e7.svg";
export { ForwardRef as ReactComponent };